export const START_CALL = "START_CALL_QUERIES_VET";
export const CALL_COMPLETED = "CALL_COMPLETED_QUERIES_VET";
export const CATCH_ERROR = "CATCH_ERROR_QUERIES_VET";
export const SELECT_FILTER = "SELECT_FILTER";
export const CLEAR_QUERY_LIST = "CLEAR_QUERY_LIST";